/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link as RouterLink } from 'react-router';

import { useNavigate, useParams } from 'js/lib/useRouter';

import { IconButton, breakpoints } from '@coursera/cds-core';
import { CloseIcon } from '@coursera/cds-icons';

import CourseraLogo from 'bundles/page/components/CourseraLogo';

import _t from 'i18n!nls/enterprise-admin-program-creation';

const bannerStyles = css`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--cds-color-white-0);
  box-shadow: inset 0 -1px 0 var(--cds-color-grey-200);
  padding: 0 var(--cds-spacing-600);
  ${breakpoints.down('sm')} {
    padding: 0 var(--cds-spacing-200);
  }
`;

export const HeaderV2 = ({ onClose, isSticky = false }: { onClose?: () => void; isSticky?: boolean }) => {
  const navigate = useNavigate();
  const { thirdPartySlug, programSlug } = useParams();

  return (
    <header
      css={[
        bannerStyles,
        isSticky &&
          css`
            position: sticky;
            top: 0;
            z-index: 100;
          `,
      ]}
      role="banner"
    >
      <RouterLink
        to={programSlug ? `/o/${thirdPartySlug}/admin/programs/${programSlug}/main` : `/o/${thirdPartySlug}/admin/home`}
        css={css`
          display: flex;
        `}
      >
        <CourseraLogo
          css={css`
            height: 16px;
          `}
        />
      </RouterLink>
      <IconButton
        component="button"
        tooltip={_t('Close')}
        variant="ghost"
        size="small"
        icon={<CloseIcon />}
        aria-label={_t('Close')}
        onClick={() => {
          if (onClose) {
            onClose();
          } else if (programSlug) {
            navigate(`/o/${thirdPartySlug}/admin/programs/${programSlug}/main`);
          } else {
            navigate(`/o/${thirdPartySlug}/admin/home`);
          }
        }}
      />
    </header>
  );
};
